import { useEffect, useState } from 'react';
import { Stakeholder } from '../pages/types/Order';

const accessRules = {
    editOrder: {
        new: ['V', 'RD', 'EC'],
        submitted: ['V', 'RD', 'EC'],
        approved: ['EC'],
        placed: []
    },
    editOrderState: {
        new: ['V', 'RD', 'EC'],
        submitted: ['RD', 'EC'],
        approved: ['EC'],
        placed: []
    },
    deleteOrder: {
        new: ['V', 'RD', 'EC'],
        submitted: ['RD', 'EC'],
        approved: ['EC'],
        placed: []
    }
};

interface ShowHideAuthProps {
    action: 'deleteOrder' | 'editOrderState' | 'editOrder',
    stakeholders: Stakeholder[],
    email: string,
    state: 'new' | 'submitted' | 'approved' | 'placed',
    children?: any,
}

const ShowHideAuth = (props: ShowHideAuthProps) => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const access = accessRules[props.action];
        if (!access) return;
        let match = props.stakeholders.filter(s => s.email?.toLowerCase() === props.email.toLowerCase());
        if (!match || !match.length) return;
        if (match.length > 1) {
            match = match.filter(m => m.role !== 'V');
        }
        const me = match[0];
        const allowedRoles: string[] = access[props.state];
        const myRole = me.role || '';
        if (allowedRoles.includes(myRole)) {
            setShow(true);
        }
    },
        [props.action, props.stakeholders, props.state, props.email]);
    if (show) {
        return props.children;
    } else {
        return null;
    }
}
export default ShowHideAuth;